var map = {
	"./image-carousel.de-CH.json": 1449,
	"./image-carousel.de-DE.json": 1450,
	"./image-carousel.en-CA.json": 1451,
	"./image-carousel.en-GB.json": 1452,
	"./image-carousel.en-IN.json": 1453,
	"./image-carousel.en-ME.json": 1454,
	"./image-carousel.en-US.json": 1455,
	"./image-carousel.es-EM.json": 1456,
	"./image-carousel.es-ES.json": 1457,
	"./image-carousel.fr-BE.json": 1458,
	"./image-carousel.fr-CA.json": 1459,
	"./image-carousel.fr-CH.json": 1460,
	"./image-carousel.nl-BE.json": 1461,
	"./image-carousel.nl-NL.json": 1462,
	"./image-carousel.pl-PL.json": 1463,
	"./image-carousel.pt-BR.json": 1464
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1448;